import { render, staticRenderFns } from "./AdministracionMigraciones.vue?vue&type=template&id=c5dcf3a2"
import script from "./AdministracionMigraciones.vue?vue&type=script&lang=js"
export * from "./AdministracionMigraciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports